import { useEffect, useRef } from 'react';
import { addTelegramBackButtonEntry, removeTelegramBackButtonEntry } from '../utils/telegram/telegramBackButtonStack';

/**
 * Хук для управління нативною кнопкою "Назад" від Telegram
 * @param isVisible - чи показувати кнопку
 * @param onBack - обробник натискання кнопки
 */
export function useTelegramBackButton(isVisible: boolean, onBack: () => void) {
  const onBackRef = useRef(onBack);
  const ownerIdRef = useRef(Symbol('TelegramBackButtonOwner'));

  // Оновлюємо ref при зміні функції
  useEffect(() => {
    onBackRef.current = onBack;
  }, [onBack]);

  useEffect(() => {
    // Capture once: owner id is stable for the lifetime of the hook instance.
    const ownerId = ownerIdRef.current;

    if (!isVisible) {
      removeTelegramBackButtonEntry(ownerId);
      return;
    }

    const handleBackClick = () => {
      onBackRef.current();
    };

    addTelegramBackButtonEntry(ownerId, handleBackClick);

    return () => {
      removeTelegramBackButtonEntry(ownerId);
    };
  }, [isVisible]);
}
